import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { EdButtonComponent } from "@edenred/components/button";
import { EdModalsService } from "@edenred/components/modals";
import { TranslocoPipe } from "@jsverse/transloco";
import { SwitchDigitalInvoiceConfirmPromptComponent } from "../switch-digital-invoice-confirm-prompt/switch-digital-invoice-confirm-prompt.component";
import { ApiService } from "../../services";
import { usersEndpointConfig } from "../../configs";
import { UpdatePreference } from "../../models/api/request/update-preference.request";
import { PREFERENCE_KEY } from "../../enums/preference-key.enum";
import { UserPreferences, UserStore } from "../../stores";

const i18Cmp = "invoice_digital_consent";

@Component({
  selector: "er-digital-invoice-consent",
  imports: [MatIconModule, RouterModule, TranslocoPipe, EdButtonComponent],
  standalone: true,
  templateUrl: "./digital-invoice-consent.component.html",
  styleUrl: "./digital-invoice-consent.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DigitalInvoiceConsentComponent {
  @Input() public hideDismissButtons = false;

  @Output()
  public closeBanner: EventEmitter<void> = new EventEmitter<void>();

  public readonly i18Cmp = i18Cmp;

  private readonly modalsService: EdModalsService = inject(EdModalsService);
  private apiService = inject(ApiService);
  private userStore = inject(UserStore);

  public closeBannerClick() {
    this.closeBanner.emit();
  }

  public openSwitchToDigitalInvoiceModal() {
    this.modalsService
      .open(SwitchDigitalInvoiceConfirmPromptComponent, {
        disableCloseOnBackdrop: true,
      })
      .afterClosed.subscribe((data) => {
        if (data) {
          this.switchToDigitalInvoicing();
        }
      });
  }

  private switchToDigitalInvoicing() {
    this.apiService
      .put<UpdatePreference, UserPreferences[]>(
        {
          preference_key: PREFERENCE_KEY.CONSENT_BANNER,
          active: false,
        },
        usersEndpointConfig.updateUserPreferences(),
      )
      .subscribe({
        next: (preferences): void => {
          this.userStore.updateUserPreferences(preferences);
        },
        error: (): void => {
          const preferences = [
            {
              user_id: "123",
              preference_key: PREFERENCE_KEY.CONSENT_BANNER,
              active: false,
            },
            {
              user_id: "123",
              preference_key: PREFERENCE_KEY.HIDE_ON_DASHBOARD,
              active: false,
            },
          ];
          this.userStore.updateUserPreferences(preferences);
        },
      });
  }

  public hideBannerOnDashboard() {
    this.apiService
      .put<UpdatePreference, UserPreferences[]>(
        {
          preference_key: PREFERENCE_KEY.HIDE_ON_DASHBOARD,
          active: false,
        },
        usersEndpointConfig.updateUserPreferences(),
      )
      .subscribe({
        next: (preferences): void => {
          this.userStore.updateUserPreferences(preferences);
        },
        error: (): void => {
          const preferences = [
            {
              user_id: "123",
              preference_key: PREFERENCE_KEY.CONSENT_BANNER,
              active: true,
            },
            {
              user_id: "123",
              preference_key: PREFERENCE_KEY.HIDE_ON_DASHBOARD,
              active: true,
            },
          ];
          this.userStore.updateUserPreferences(preferences);
        },
      });
  }
}
